import { Button, Typography } from "@mui/material"
import Grid from "@mui/material/Unstable_Grid2/Grid2"
import OneInput from "../../../OneInput/OneInput"
import OneSelect from "../../../OneSelect/OneSelect"
import { useContext, useState } from "react"
import { CondominiosContext } from "../../../../Providers/CondominiosContext/CondominiosContext"
import { WebSocketContext } from "../../../../Providers/WebSocket/WebSocketContext"
import ComboBox from "../../../ComboBox/ComboBox"

const newSx = {
    input: {
        height: { xs: '30px', lg: '21px', xl: '30px' },
        fontSize: { lg: '10px', xl: '15px' }
    },
    label: {
        fontSize: { lg: '13px', xl: '15px' }
    }
}

const PesquisarLivroAta = ({ filtros, setFiltros }) => {
    const { condominios } = useContext(CondominiosContext)
    const optionsCondominios = condominios.map((condominio) => {
        return { nome: `${condominio.id_central}-${condominio.nome} `, id_central: condominio.id_central }
    })

    const { sendWs } = useContext(WebSocketContext)
    const [initialData] = useState(filtros)
    const [formData, setFormData] = useState({})

    const handleChange = (event) => {
        if (event.target.value != undefined) {
            if (event.target.type == 'checkbox') {
                setFormData({ ...formData, [event.target.name]: event.target.checked })
            } else {
                setFormData({ ...formData, [event.target.name]: event.target.value })
            }
        }
    }

    const pesquisaLivroAta = () => {
        sendWs("buscarTodasObs", { filtros: formData })
    }
    return (
        <Grid>
            <Grid container spacing={1} xs={12} sx={{ margin: 0, padding: 0, alignItems: 'space-between' }}>
                <Grid xs={1.5} lg={1.5} xl={1} >
                    <Typography sx={newSx.label}>Pesquisar: </Typography>
                </Grid>
                <Grid xs={4} lg={3} xl={4}>
                    <OneInput
                        newSx={newSx.input}
                        placeholder={"Alguma palavra dentro do texto"}
                        defaultValue={initialData?.pesquisa || ""}
                        name="pesquisa"
                        onChange={handleChange}
                    />
                </Grid>
                <Grid xs={3} lg={2.5} xl={1.8}>
                    <Typography sx={newSx.label}>Cond./Empresa: </Typography>
                </Grid>
                <Grid xs>
                    <ComboBox
                        newSx={newSx.input}
                        options={[{ id_central: '', nome: 'Todos' }, ...optionsCondominios]}
                        defaultValue={initialData?.id_central || ''}
                        label="nome"
                        valor="id_central"
                        name="id_central"
                        onChange={handleChange}
                        separado={true}
                        todos={true}
                    />
                </Grid>
            </Grid>
            <Grid container spacing={1} xs={12} sx={{ margin: 0, padding: 0, alignItems: 'center' }}>
                <Grid xs={1} lg={1.5} xl={1} >
                    <Typography sx={newSx.label}>Dt inicial: </Typography>
                </Grid>
                <Grid xs={3} lg={2.5} xl={1.7} >
                    <OneInput
                        newSx={newSx.input}
                        defaultValue={initialData?.data_inicial}
                        type="date"
                        name="data_inicial"
                        onChange={handleChange}
                    />
                </Grid>
                <Grid xs={1} lg={1.2} xl={0.8} >
                    <Typography sx={newSx.label}>Dt final: </Typography>
                </Grid>
                <Grid xs={3} lg={2.5} xl={1.7} >
                    <OneInput
                        newSx={newSx.input}
                        defaultValue={initialData?.data_final}
                        type="date"
                        name="data_final"
                        onChange={handleChange}
                    />
                </Grid>
                <Grid xs={1} lg={1}>
                    <Typography sx={newSx.label}>Status: </Typography>
                </Grid>
                <Grid xs={3} lg={2} xl={3}>
                    <OneSelect
                        newSx={newSx.input}
                        options={[{ id: 1, descricao: 'Abertos' }, { id: 0, descricao: 'Finalizados' }, { id: 'all', descricao: 'Ambos' }]}
                        defaultValue={initialData?.status || 1}
                        name="status"
                        onChange={handleChange}
                    />
                </Grid>
                <Grid xs lg xl sx={{ display: 'flex', justifyContent: 'end' }} >
                    <Button
                        variant="contained"
                        color="one_primary"
                        sx={{
                            height: { lg: '20px', xl: '30px' },
                            fontSize: { lg: '11px', xl: '14px' }
                        }}
                        onClick={pesquisaLivroAta}
                    >Filtrar</Button>
                </Grid>
            </Grid>
        </Grid>
    )
}

export default PesquisarLivroAta
